<template>
  <div>
    <b>Documento Bodega: {{ ObjectSelected.codigo_devolucion }}</b>
    <ul class="flex mt-5">
      <li class="mr-3">
        Seleccione la empresa:
      </li>
      <li class="mr-3">
        <vs-radio class="ml-5" v-model="empresaSelected" v-for="(item,key) in arrayEmpresas" :key="key" vs-name="radios1empresaSelected" :vs-value="item.id_empresa">{{ item.descripcion_corta }}</vs-radio>
      </li>
    </ul>
    <vs-divider></vs-divider>
    <div v-if="ven_codigoSinEmpresa == '' && ven_codigoProlipa == '' && ven_codigoCalmed == ''">
      <p class="text-danger font-bold text-center text-2xl">Primero finalize para poder imprimir</p>
    </div>
    <div v-else>
      <div class="flex justify-center mt-5" v-if="(ven_codigoSinEmpresa != '' || ven_codigoProlipa != '' || ven_codigoCalmed != '') && ObjectSelected.estado == '2'">
        <vs-button @click="m_imprimirTodos('12px','Reporte' ,'0px','')"><i class="fa-solid fa-print"></i> Imprimir</vs-button>
      </div>
    </div>
    <div id="seccionImprimir2" class="mt-5">
      <div>
        <div v-if="ven_codigoSinEmpresa == '' && ven_codigoProlipa == '' && ven_codigoCalmed == ''">
        </div>
        <div v-else>
          <h4 style="text-align: center;" v-if="empresaSelected == 0">DEVOLUCIÓN {{ ven_codigoSinEmpresa  }}</h4>
          <h4 style="text-align: center;" v-if="empresaSelected == 1">DEVOLUCIÓN {{ ven_codigoProlipa  }}</h4>
          <h4 style="text-align: center;" v-if="empresaSelected == 3">DEVOLUCIÓN {{ ven_codigoCalmed  }}</h4>
        </div>

        <table style="width: 100%; border-collapse: collapse; border: none;">
            <tr style="border: none;">
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        <b>Fecha:</b>
                    </p>
                </td>
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        {{ ObjectSelected.created_at }}
                    </p>
                </td>
            </tr>
            <tr style="border: none;">
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        <b>Cliente:</b>
                    </p>
                </td>
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        {{ ObjectSelected.institucion ? ObjectSelected.institucion.nombreInstitucion : 'Sin cliente' }}
                    </p>
                </td>
            </tr>
            <tr style="border: none;">
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        <b>Periodo:</b>
                    </p>
                </td>
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        {{ ObjectSelected.periodo }}
                    </p>
                </td>
            </tr>
            <tr style="border: none;">
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        <b>Cantidad Cajas:</b>
                    </p>
                </td>
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        {{ ObjectSelected.cantidadCajas }}
                    </p>
                </td>
            </tr>
            <tr style="border: none;">
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        <b>Cantidad Paquetes:</b>
                    </p>
                </td>
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        {{ ObjectSelected.cantidadPaquetes }}
                    </p>
                </td>
            </tr>
            <!--usuario creador-->
            <tr style="border: none;">
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        <b>Usuario Creador:</b>
                    </p>
                </td>
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        {{ ObjectSelected.usuario ? ObjectSelected.usuario.nombres + ' ' + ObjectSelected.usuario.apellidos : '' }}
                    </p>
                </td>
            </tr>
            <!--documento bodega-->
            <tr style="border: none;">
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        <b>Documento Bodega:</b>
                    </p>
                </td>
                <td style="border: none; text-align: left; padding-left: 0px;">
                    <p class="letra" style="font-size: 11px; margin: 0;">
                        {{ ObjectSelected.codigo_devolucion }}
                    </p>
                </td>
            </tr>
        </table>
        <br>
        <p v-if="empresaSelected == 0"><b>Total Codigos: {{ cantidadSinEmpresa }}</b></p>
        <p v-if="empresaSelected == 1"><b>Total Codigos: {{ cantidadProlipa }}</b></p>
        <p v-if="empresaSelected == 3"><b>Total Codigos: {{ cantidadCalmed }}</b></p>
      </div>
      <br><br>
      <div class="vx-row">
        <!--SIN EMPRESA-->
        <div class="vx-col w-full" v-if="empresaSelected == 0">
          <div v-if="arraySinEmpresa.length > 0">
            <TableDevolucionReutilizableVue
            :tableData="arraySinEmpresa"
            :columnWidths="['10%','20%','5%','5%','10%','10%','10%','10%']"
            :titulo="'Libros Sin Empresa'"
            :headers="['Código','Libro','Cantidad','Descuento %','Precio','Subtotal','Total','Empresa','Observación código']"
            :fieldKeys="['codigo','nombrelibro','cantidad','ven_desc_por','precio','subtotal','total','descripcion_corta','observacion_codigo']"
            :subtotal="subtotalSinEmpresa"
            :total="totalSinEmpresa"
            :ifTotales="Number(1)"
            />
          </div>
        </div>
        <!--PROLIPA-->
        <div class="vx-col w-full" v-if="empresaSelected == 1">
          <div v-if="arrayProlipa.length > 0">
            <TableDevolucionReutilizableVue
            :tableData="arrayProlipa"
            :columnWidths="['10%','20%','5%','5%','10%','10%','10%','10%']"
            :titulo="'Libros Empresa Prolipa'"
            :headers="['Código','Libro','Cantidad','Descuento %','Precio','Subtotal','Total','Empresa','Observación código']"
            :fieldKeys="['codigo','nombrelibro','cantidad','ven_desc_por','precio','subtotal','total','descripcion_corta','observacion_codigo']"
            :subtotal="subtotalProlipa"
            :total="totalProlipa"
            :ifTotales="Number(1)"
            />
          </div>
        </div>
        <!--CALMED-->
        <div class="vx-col w-full" v-if="empresaSelected == 3">
          <div v-if="arrayCalmed.length > 0">
            <TableDevolucionReutilizableVue
            :tableData="arrayCalmed"
            :columnWidths="['10%','20%','5%','5%','10%','10%','10%','10%']"
            :titulo="'Libros Empresa Calmed'"
            :headers="['Código','Libro','Cantidad','Descuento %','Precio','Subtotal','Total','Empresa','Observación código']"
            :fieldKeys="['codigo','nombrelibro','cantidad','ven_desc_por','precio','subtotal','total','descripcion_corta','observacion_codigo']"
            :subtotal="subtotalCalmed"
            :total="totalCalmed"
            :ifTotales="Number(1)"
            />
          </div>
        </div>
      </div>
      <br><br><br>
      <!--tabla para la observaciones-->
      <table style="width: 100%; border-collapse: collapse; border: none;">
        <tr style="border: none;">
          <td style="border: none; text-align: left; padding-left: 0px;">
              <p class="letra" style="font-size: 11px; margin: 0;">
                  <b>Observaciones:</b>
              </p>
              <p class="letra" style="font-size: 11px; margin: 0;">
                {{ ObjectSelected.observacion }}
            </p>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import imprimirMixin from "@/mixins/Pedidosmix";
const TableDevolucionReutilizableVue = () => import("./TableDevolucionReutilizable.vue");
export default {
  mixins: [imprimirMixin],
  components:{
    TableDevolucionReutilizableVue
  },
  data() {
    return{
      empresaSelected:null,
      arraySinEmpresa:[],
      arrayProlipa:[],
      arrayCalmed:[],
      //subtotales
      subtotalSinEmpresa:0,
      subtotalProlipa:0,
      subtotalCalmed:0,
      //totales
      totalSinEmpresa:0,
      totalProlipa:0,
      totalCalmed:0,
      //total codigos
      cantidadSinEmpresa:0,
      cantidadProlipa:0,
      cantidadCalmed:0,
      //ven codigos
      ven_codigoSinEmpresa:'',
      ven_codigoProlipa:'',
      ven_codigoCalmed:'',
    }
  },
  props:{
    ObjectSelected:{
      type:Object,
      default:function(){
        return {}
      }
    },
    arrayCodigosDevueltosSinEmpresa:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayCodigosDevueltosProlipa:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayCodigosDevueltosCalmed:{
      type:Array,
      default:function(){
        return []
      }
    },
    //regalados sin liquidar
    arrayCodigosRegaladosSinEmpresa:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayCodigosRegaladosProlipa:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayCodigosRegaladosCalmed:{
      type:Array,
      default:function(){
        return []
      }
    },
    //regalados liquidados
    arrayCodigosRegaladosSinEmpresaLiquidados:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayCodigosRegaladosProlipaLiquidados:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayCodigosRegaladosCalmedLiquidados:{
      type:Array,
      default:function(){
        return []
      }
    },
    //actas sin liquidar
    arrayCodigosRegaladosSinEmpresaActas:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayCodigosRegaladosProlipaActas:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayCodigosRegaladosCalmedActas:{
      type:Array,
      default:function(){
        return []
      }
    },
    //actas liquidados
    arrayCodigosRegaladosSinEmpresaActasLiquidados:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayCodigosRegaladosProlipaActasLiquidados:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayCodigosRegaladosCalmedActasLiquidados:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayCombosProlipa:{
      type:Array,
      default:function(){
        return []
      }
    },
     arrayCombosCalmed:{
      type:Array,
      default:function(){
        return []
      }
    },
    arrayEmpresas:{
      type:Array,
      default:function(){
        return []
      }
    }
  },
  mounted(){
    let me = this
    me.start()
  },
  methods:{
    start(){
      let me = this
      me.arraySinEmpresa    = []
      me.arrayProlipa       = []
      me.arrayCalmed        = []

      me.subtotalSinEmpresa = 0
      me.subtotalProlipa    = 0
      me.subtotalCalmed     = 0

      me.totalSinEmpresa    = 0
      me.totalProlipa       = 0
      me.totalCalmed        = 0

      me.ven_codigoSinEmpresa = ''
      me.ven_codigoProlipa    = ''
      me.ven_codigoCalmed     = ''
      //seleccionar el primero elemento de la empresa
      me.empresaSelected = me.arrayEmpresas[0].id_empresa
      //unir todos los codigos en array arraySinEmpresa
      me.arraySinEmpresa  = [...me.arrayCodigosDevueltosSinEmpresa,...me.arrayCodigosRegaladosSinEmpresa,...me.arrayCodigosRegaladosSinEmpresaActas, ...me.arrayCodigosRegaladosSinEmpresaLiquidados,...me.arrayCodigosRegaladosSinEmpresaActasLiquidados]
      me.arrayCalmed      = [...me.arrayCodigosDevueltosCalmed,...me.arrayCodigosRegaladosCalmed,...me.arrayCodigosRegaladosCalmedActas,...me.arrayCodigosRegaladosCalmedLiquidados,...me.arrayCodigosRegaladosCalmedActasLiquidados ,...me.arrayCombosCalmed]
      me.arrayProlipa     = [...me.arrayCodigosDevueltosProlipa,...me.arrayCodigosRegaladosProlipa,...me.arrayCodigosRegaladosProlipaActas,...me.arrayCodigosRegaladosProlipaLiquidados,...me.arrayCodigosRegaladosProlipaActasLiquidados ,...me.arrayCombosProlipa]

      //ordenar arraySinEmpresa por codigo
      me.arraySinEmpresa.sort((a, b)  => a.codigo.localeCompare(b.codigo));
      me.arrayProlipa.sort((a, b)     => a.codigo.localeCompare(b.codigo));
      me.arrayCalmed.sort((a, b)      => a.codigo.localeCompare(b.codigo));

      //calcular los subtotales
      me.subtotalSinEmpresa = me.arraySinEmpresa.reduce((total, item) => total + parseFloat(item.subtotal), 0);
      me.subtotalProlipa    = me.arrayProlipa.reduce((total, item) => total + parseFloat(item.subtotal), 0);
      me.subtotalCalmed     = me.arrayCalmed.reduce((total, item) => total + parseFloat(item.subtotal), 0);

      // Calcular los totales
      me.totalSinEmpresa    = me.arraySinEmpresa.reduce((total, item) => total + parseFloat(item.total), 0);
      me.totalProlipa       = me.arrayProlipa.reduce((total, item) => total + parseFloat(item.total), 0);
      me.totalCalmed        = me.arrayCalmed.reduce((total, item) => total + parseFloat(item.total), 0);

      //sumar la cantidad
      me.cantidadSinEmpresa = me.arraySinEmpresa.reduce((total, item) => total + parseFloat(item.cantidad), 0);
      me.cantidadProlipa    = me.arrayProlipa.reduce((total, item) => total + parseFloat(item.cantidad), 0);
      me.cantidadCalmed     = me.arrayCalmed.reduce((total, item) => total + parseFloat(item.cantidad), 0);

      me.getDocumentosEmpresa()
    },
    getDocumentosEmpresa(){
      let me = this
      var url = `devoluciones?getDocumentosFinalizados=1&idDocumentoPadre=${ me.ObjectSelected.id }`
      this.$http.get(this.$server_url+url)
      .then(function (res) {
        let datos = res.data
        //colocar los codigos en el arrayEmpresas
        me.arrayEmpresas.forEach(element => {
          if(element.id_empresa == 0)
          {
            let ifExistDocument = datos.filter(p => p.id_empresa == 0)
            if(ifExistDocument.length > 0){
              me.ven_codigoSinEmpresa = ifExistDocument[0].ven_codigo
            }else{
              me.ven_codigoSinEmpresa = ''
            }
            element.arrayCodigos = me.arraySinEmpresa;
          }

          if(element.id_empresa == 1)
          {
            let ifExistDocument = datos.filter(p => p.id_empresa == 1)
            if(ifExistDocument.length > 0){
              me.ven_codigoProlipa = ifExistDocument[0].ven_codigo
            }else{
              me.ven_codigoProlipa = ''
            }
            element.arrayCodigos = me.arrayProlipa;
          }

          if(element.id_empresa == 3)
          {
            let ifExistDocument = datos.filter(p => p.id_empresa == 3)
            if(ifExistDocument.length > 0){
              me.ven_codigoCalmed = ifExistDocument[0].ven_codigo
            }else{
              me.ven_codigoCalmed = ''
            }
            element.arrayCodigos = me.arrayCalmed;
          }
        });
        //SI NO EXISTE DOCUMENTOS PERMITO GUARDAR PARA FINALIZAR EL DOCUMENTO
        if(datos.length == 0 || me.ObjectSelected.estado == '1'){
          me.$emit('changeFinished',me.arrayEmpresas)
        }
      })
      .catch(function (error) {
          console.log(error + ' error');
      })
    }
  }
}
</script>
